import { render, staticRenderFns } from "./GAuthTextField.vue?vue&type=template&id=2220007c&scoped=true&"
import script from "./GAuthTextField.vue?vue&type=script&lang=ts&"
export * from "./GAuthTextField.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthTextField.vue?vue&type=style&index=0&id=2220007c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220007c",
  null
  
)

export default component.exports